export default {
  title: 'Launchpad',
  valueChainAssessment: 'Value Chain Assessment',
  materialityAssessment: 'Materiality Assessment local',
  settings: 'Settings',
};
